export const getAppsConfigMock = {
  appIds: ['axi-wrapper', 'iosim-plus', 'web3dtool'],
};
